import './Register.css';
import React, { useEffect, useCallback } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import { withTranslate } from 'react-redux-multilingual';
import { connect } from 'react-redux';
import CryptoJS from "crypto-js";
import PasswordStrengthBar from 'react-password-strength-bar';
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import LinkMui from '@mui/material/Link';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import InputAdornment from '@mui/material/InputAdornment';
import FormControl from '@mui/material/FormControl';
import IconButton from '@mui/material/IconButton';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import FormHelperText from '@mui/material/FormHelperText';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';

import {
    ValidateCompanyName,
    ValidateTelNumber,
    ValidateEmail,
    ValidatePersonName,
    ValidatePassword,
} from '../../../libraries/Tool';

import { 
    ValidateUserInfo,
    Register as RegisterUser,
    VnpayCreatePaymentUrl,
    VnpayReturnUrl,
} from '../../../services/Auth.service';

function Register(props) {
    const { translate, UserInfor, BackDrop, SnackbarAlert } = props;
    const plans = ["standard", "premium", "enterprise"];
    const { plan, payments } = useParams();
    const navigate = useNavigate();
    const [companyName, setCompanyName] = React.useState();
    const [companyNameInvalid, setCompanyNameInvalid] = React.useState(false);
    const [telNumber, setTelNumber] = React.useState();
    const [telNumberInvalid, setTelNumberInvalid] = React.useState(false);
    const [email, setEmail] = React.useState();
    const [emailInvalid, setEmailInvalid] = React.useState(false);
    const [firstName, setFirstName] = React.useState();
    const [firstNameInvalid, setFirstNameInvalid] = React.useState(false);
    const [lastName, setLastName] = React.useState();
    const [lastNameInvalid, setLastNameInvalid] = React.useState(false);
    const [password, setPassword] = React.useState();
    const [passwordInvalid, setPasswordInvalid] = React.useState(false);
    const [showPassword, setShowPassword] = React.useState(false);

    const handleOnChangeCompanyName = (e) => {
        setCompanyName(e.target.value);
        setCompanyNameInvalid(!ValidateCompanyName(e.target.value));
    }

    const handleOnChangeTelNumber = (e) => {
        setTelNumber(e.target.value);
        setTelNumberInvalid(!ValidateTelNumber(e.target.value));
    }

    const handleOnChangeEmail = (e) => {
        setEmail(e.target.value);
        setEmailInvalid(!ValidateEmail(e.target.value));
    }

    const handleOnChangeFirstName = (e) => {
        setFirstName(e.target.value);
        setFirstNameInvalid(!ValidatePersonName(e.target.value));
    }

    const handleOnChangeLastName = (e) => {
        setLastName(e.target.value);
        setLastNameInvalid(!ValidatePersonName(e.target.value));
    }

    const handleOnChangePassword = (e) => {
        setPassword(e.target.value);
        setPasswordInvalid(!ValidatePassword(e.target.value));
    }

    const handleCloseSnackbarAlert = () => {
        props.dispatch({ type: 'UPDATE_SNACKBARALERT', SnackbarAlert: { ...SnackbarAlert, open: false } });
    }

    const onClickAgree = async (e) => {
        e.preventDefault();
        if((plan === 'enterprise')) {
            if(!companyName) setCompanyNameInvalid(true);
            if(!telNumber) setTelNumberInvalid(true);
        } else {
            setCompanyNameInvalid(false);
            setTelNumberInvalid(false);
        };
        if(!email) setEmailInvalid(true);
        if(!firstName) setFirstNameInvalid(true);
        if(!lastName) setLastNameInvalid(true);
        if(!password) setPasswordInvalid(true);
        const locale = localStorage.getItem('_locale') || 'en';
        if(
            !companyNameInvalid &&
            !telNumberInvalid &&
            !emailInvalid && 
            !firstNameInvalid && 
            !lastNameInvalid && 
            !passwordInvalid
        ) {
            ValidateUserInfo({
                companyName
                ,telNumber
                ,email
                ,firstName
                ,lastName
                ,password
                ,plan
                ,locale
            })
            .then(res => {
                localStorage.setItem("_registerInfor", JSON.stringify({companyName, telNumber, email, firstName, lastName, password: CryptoJS.AES.encrypt(password, process.env.REACT_APP_CRYPTO_PASSWORD).toString() }))
                if(plan === "standard") {
                    handelSubmitRegister(companyName, telNumber, email, firstName, lastName, password, plan); 
                } else {
                    VnpayCreatePaymentUrl({
                        companyName
                        ,telNumber
                        ,email
                        ,firstName
                        ,lastName
                        ,password
                        ,plan
                        ,locale: (locale === 'vi' ? 'vn' : locale)
                    })
                    .then(res => {
                        // console.log(res.data.vnpUrl);
                        window.location.href = res.data.vnpUrl;
                    })
                    .catch(err => {
                        // console.log(err);
                        setTimeout(() => {
                            props.dispatch({ 
                                type: 'UPDATE_SNACKBARALERT', 
                                SnackbarAlert: {
                                    open: true,
                                    severity: err?.response?.data?.status,
                                    message: translate(`${err?.response?.data?.msg}`),
                                    handleClose: () => handleCloseSnackbarAlert()
                                } 
                            });
                        }, 1000)
                    })
                }
            })
            .catch(err => {
                setTimeout(() => {
                    props.dispatch({ 
                        type: 'UPDATE_SNACKBARALERT', 
                        SnackbarAlert: {
                            open: true,
                            severity: err?.response?.data?.status,
                            message: translate(`${err?.response?.data?.msg}`),
                            handleClose: () => handleCloseSnackbarAlert()
                        } 
                    });
                }, 1000)
            })
        }
    }

    const handelSubmitRegister = (companyName, telNumber, email, firstName, lastName, password, plan, orderId) => {
        let locale = localStorage.getItem('_locale') || 'en';
        if(
            (plan === 'enterprise' && (!companyName || !telNumber)) ||
            !email ||
            !firstName ||
            !lastName ||
            !password ||
            !plan
        ) return; 
        props.dispatch({ type: 'UPDATE_BACKDROP', BackDrop: true });
            RegisterUser({
                companyName
                ,telNumber
                ,email
                ,firstName
                ,lastName
                ,password
                ,plan
                ,locale
                ,orderId
            })
            .then(res => {
                localStorage.setItem('_userinfor', JSON.stringify(res?.data?.userInfor));
                props.dispatch({ type: 'UPDATE_USER_INFOR', UserInfor: res?.data?.userInfor });
                props.dispatch({ type: 'UPDATE_BACKDROP', BackDrop: false });
                localStorage.removeItem("_registerInfor");
                navigate("/verify-email");
            })
            .catch(err => {
                setTimeout(() => {
                    props.dispatch({ 
                        type: 'UPDATE_SNACKBARALERT', 
                        SnackbarAlert: {
                            open: true,
                            severity: err?.response?.data?.status,
                            message: translate(`${err?.response?.data?.msg}`),
                            handleClose: () => handleCloseSnackbarAlert()
                        } 
                    });
                }, 1000)
                props.dispatch({ type: 'UPDATE_BACKDROP', BackDrop: false });
            })
    }

    useEffect(() => {
        let registerInfor = localStorage.getItem("_registerInfor");
        if(registerInfor) {
            registerInfor = JSON.parse(registerInfor);
            setCompanyName(registerInfor.companyName);
            setTelNumber(registerInfor.telNumber);
            setEmail(registerInfor.email);
            setFirstName(registerInfor.firstName);
            setLastName(registerInfor.lastName);
            setPassword((CryptoJS.AES.decrypt(registerInfor?.password.toString(), process.env.REACT_APP_CRYPTO_PASSWORD)).toString(CryptoJS.enc.Utf8));
        }
    }, [])

    useEffect(() => {
        switch (payments) {
            case "vnpay":
                let vnp_Params = Object.fromEntries(new URLSearchParams(window.location.search));
                VnpayReturnUrl(vnp_Params)
                .then(res => {
                    // console.log(res.data);
                    props.dispatch({ 
                        type: 'UPDATE_SNACKBARALERT', 
                        SnackbarAlert: {
                            open: true,
                            severity: res?.data?.status,
                            message: translate(`${res?.data?.msg}`),
                            handleClose: () => handleCloseSnackbarAlert()
                        } 
                    });
                    handelSubmitRegister(res.data.companyName, res.data.telNumber, res.data.email, res.data.firstName, res.data.lastName, res.data.password, res.data.plan, res.data.orderId);
                })
                .catch(err => {
                    console.log(err);
                    props.dispatch({ 
                        type: 'UPDATE_SNACKBARALERT', 
                        SnackbarAlert: {
                            open: true,
                            severity: err?.response?.data?.status,
                            message: translate(`${err?.response?.data?.msg}`),
                            handleClose: () => handleCloseSnackbarAlert()
                        } 
                    });
                    navigate(`/register/${plan}`)
                })
                break;
        }
    }, [payments])

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
        if(!plans.includes(plan)) {
            navigate("/");
        }
    }, [])

    return (
        <div>
            <Container maxWidth="xl" sx={{ my: 20 }}>
                <Box>
                    <Box pb={2}>
                        <RadioGroup
                            row
                            value={plan}
                            onChange={(e) => navigate(`/register/${e.target.value}`)}
                            sx={{ justifyContent: "center" }}
                        >
                            <FormControlLabel value="standard" control={<Radio />} label={translate('standard')} />
                            <FormControlLabel value="premium" control={<Radio />} label={translate('premium')} />
                            <FormControlLabel value="enterprise" control={<Radio />} label={translate('enterprise')} />
                        </RadioGroup>
                    </Box>
                    <Typography variant="h4" gutterBottom component="div" sx={{ fontWeight: "bold" }}>
                        {translate(`tryfor${plan}`)}
                    </Typography>
                    <Typography variant="h6" gutterBottom component="div" sx={{ color: "#586978", fontWeight: "bold", mb: "3em" }}>
                        {translate(`tryfor${plan}description`)}&nbsp;
                        {plan !== "standard" && `(${translate(`${plan}price`)}/${translate('months')})`}
                        <br />
                        {plan === 'standard' && translate(`freeupto30daysnocreditcardrequired`)}
                    </Typography>
                </Box>
                <Box
                    component="form"
                    noValidate
                    autoComplete="off"
                    className="register-box-main"
                    onSubmit={onClickAgree}
                >
                    <Grid container spacing={2}>
                        {plan === 'enterprise' &&
                        <>
                            <Grid item xs={12}>
                                <TextField
                                    autoFocus={plan === 'enterprise'}
                                    required
                                    fullWidth
                                    type="text"
                                    id="companyName"
                                    name="companyName"
                                    autoComplete='none'
                                    label={translate('companyname')}
                                    value={companyName}
                                    onChange={handleOnChangeCompanyName}
                                    error={
                                        companyNameInvalid
                                    }
                                    helperText={
                                        (companyNameInvalid) ? translate('pleaseenteravalidcompanyname') :
                                        ""
                                    }
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    required
                                    fullWidth
                                    type="text"
                                    id="telNumber"
                                    name="telNumber"
                                    pattern="/^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im"
                                    autoComplete='none'
                                    label={translate('telnumber')}
                                    value={telNumber}
                                    onChange={handleOnChangeTelNumber}
                                    error={
                                        telNumberInvalid
                                    }
                                    helperText={
                                        (telNumberInvalid) ? translate('pleaseenteravalidtelnumber') :
                                        ""
                                    }
                                />
                            </Grid>
                        </>}
                        <Grid item xs={12}>
                            <TextField
                                autoFocus={plan !== 'enterprise'}
                                required
                                fullWidth
                                type="email"
                                id="email"
                                name="email"
                                autoComplete='none'
                                label={translate('emailaddress')}
                                value={email}
                                onChange={handleOnChangeEmail}
                                error={
                                    emailInvalid
                                }
                                helperText={
                                    (emailInvalid) ? translate('pleaseenteravalidemailaddress') :
                                    ""
                                }
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <TextField
                                required
                                fullWidth
                                type="text"
                                id="firstName"
                                name="firstName"
                                autoComplete='on'
                                label={translate('firstname')}
                                value={firstName}
                                onChange={handleOnChangeFirstName}
                                error={firstNameInvalid}
                                helperText={
                                    firstNameInvalid ? translate('pleaseenteravalidfirstname') :
                                    ""
                                }
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <TextField
                                required
                                fullWidth
                                type="text"
                                id="lastName"
                                name="lastName"
                                autoComplete='none'
                                label={translate('lastname')}
                                value={lastName}
                                onChange={handleOnChangeLastName}
                                error={lastNameInvalid}
                                helperText={
                                    lastNameInvalid ? translate('pleaseenteravalidlastname') :
                                    ""
                                }
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <FormControl required fullWidth variant="outlined">
                                <InputLabel error={passwordInvalid} htmlFor="password">{translate('password')}</InputLabel>
                                <OutlinedInput
                                    id="password"
                                    type={showPassword ? 'text' : 'password'}
                                    value={password}
                                    onChange={handleOnChangePassword}
                                    endAdornment={
                                        <InputAdornment position="end">
                                            <IconButton
                                            onClick={() => setShowPassword(!showPassword) }
                                            onMouseDown={(event) =>  event.preventDefault() }
                                            edge="end"
                                            >
                                            {showPassword ? <Visibility /> : <VisibilityOff />}
                                            </IconButton>
                                        </InputAdornment>
                                    }
                                    label={translate('password')}
                                    error={passwordInvalid}
                                />
                                {passwordInvalid && (
                                <FormHelperText error id="password">
                                {translate('pleaseenteravalidpassword')}
                                </FormHelperText>)}
                            </FormControl>
                            <PasswordStrengthBar 
                                password={password}
                                scoreWords={[translate('weak'), translate('okay'), translate('good'), translate('strong'), translate('stronger')]}
                                minLength={8}
                                shortScoreWord={((password?.length < 8)) ? translate('tooshort') : ''}
                            />
                        </Grid>
                        <Grid item xs={12} sx={{ pt: 10, textAlign: "left" }}>
                            <Typography variant="subtitle1" gutterBottom component="div">
                                {translate('agreeconfirm')}
                                <LinkMui component={Link} underline="none" to="/privacy-policy">{translate('privacypolicy')}</LinkMui>
                            </Typography>
                        </Grid>
                        <Grid item xs={12} sx={{ display: "flex", justifyContent: "left", pt: 10 }}>
                            <Button 
                                fullWidth={true} 
                                variant="contained" 
                                color="primary" 
                                disableElevation
                                type="submit"
                                onClick={onClickAgree}
                                disabled={(plan === 'enterprise' && (!companyName || !telNumber)) || !email || emailInvalid || !password || passwordInvalid ||  !firstName || !lastName}
                            >
                            {translate(`agreetryfor${plan}`)}
                            </Button>
                        </Grid>
                    </Grid>
                </Box>
            </Container>
        </div>
    )
}

function mapStateToProps(state) {
    return {
      UserInfor: state.UserInfor,
      BackDrop: state.BackDrop,
      SnackbarAlert: state.SnackbarAlert,
    }
}

export default connect(mapStateToProps)(withTranslate(Register));